export const arrayOfAll = () => (array) => array;
